<template>
  <section v-if="!useV2026TagSettings" class="p-3">
    <h4 v-if="!hasSystem">ตั้งค่าแท็ก</h4>
    <h4 v-else>ตั้งค่าหัวข้อสนทนากับลูกค้า</h4>
    <div class="mt-3">
      <button class="btn btn-primary" @click="displayModal()">
        <i class="fas fa-plus"></i>
        <span v-if="!hasSystem">&nbsp;เพิ่มแท็ก</span>
        <span v-else>&nbsp;เพิ่มหัวข้อ</span>
      </button>
    </div>
    <div class="py-3">
      <b-nav tabs justified v-if="!hasSystem">
        <b-nav-item :active="queryParams.customer_type === 'customer'"
                    @click="loadTags('customer')">
          <i class="fas fa-user"></i>&nbsp;&nbsp;แท็กฝั่งคุณลูกค้า
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type.includes('professional', 'professional_secondary')"
                    @click="loadTags('professional')">
          <i class="far fa-id-badge"></i>&nbsp;&nbsp;แท็กฝั่งผู้สมัคร
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'beneat_professional'"
                    @click="loadTags('beneat_professional')">
          <i class="fas fa-female"></i>&nbsp;&nbsp;แท็กฝั่งคุณแม่บ้าน
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'sales_product_customer'"
                    @click="loadTags('sales_product_customer')">
          <i class="fas fa-user-circle"></i>&nbsp;&nbsp;แท็กฝั่งคุณลูกค้า (Sales)
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'recruitment_customer'"
                    @click="loadTags('recruitment_customer')">
          <i class="fas fa-user"></i>&nbsp;&nbsp;แท็กฝั่งคุณลูกค้า (Recruit)
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'recruitment_professional'"
                    @click="loadTags('recruitment_professional')">
          <i class="fas fa-female"></i>&nbsp;&nbsp;แท็กฝั่งคุณแม่บ้าน (Recruit)
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'mari_customer'"
                    @click="loadTags('mari_customer')">
          <i class="fas fa-user"></i>&nbsp;&nbsp;แท็กฝั่งคุณลูกค้า (Mari)
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'mari_professional'"
                    @click="loadTags('mari_professional')">
          <i class="far fa-id-badge"></i>&nbsp;&nbsp;แท็กฝั่งผู้สมัคร (Mari)
        </b-nav-item>
      </b-nav>
    </div>
    <div v-if="!hasSystem">

      <draggable v-model="tags" @change="sortingEvent">
        <transition-group>
          <div v-for="(tag) in tags" :key="tag.id">
            <template v-if="tag.id">
              <div class="d-flex justify-content-start align-items-center mb-3 cursor-pointer">
                <div class="rounded-left p-2"
                     :style="`background-color: ${tag.color}; border: 1px ${tag.color};`">
                  <i class="fa fa-tag text-white"></i>
                </div>
                <div class="border p-2 text-small flex-grow-1 bg-white rounded-right">
                  <div class="row">
                    <div class="col-10">{{ tag.name }}</div>
                    <div class="col-2 text-right text-secondary">
                      <i class="fa fa-bars"></i>
                    </div>
                  </div>
                </div>
                <div class="px-4">
                  <span role="button" @click="confirmDeleteTag(tag)">
                    <i class="fa fa-trash-alt text-muted"></i>
                  </span>
                </div>
              </div>
            </template>
          </div>

        </transition-group>
      </draggable>
    </div>
    <div v-else>
      <div v-for="(multiLevelTag, index) in multiLevelTags" :key="index">
        <div class="d-flex justify-content-start align-items-center mb-3">
          <div class="rounded-left p-2"
               :style="`background-color: ${multiLevelTag.color}; border: 1px ${multiLevelTag.color};`">
            <i class="fa fa-hashtag text-white"></i>
          </div>
          <div class="border p-2 text-small flex-grow-1 bg-white rounded-right">
            {{ multiLevelTag.name }}
          </div>
          <div class="px-4 text-small text-secondary">
            <span v-if="multiLevelTag.can_select">
              <i class="fas fa-check text-success"></i> กดเลือกได้
            </span>
            <span v-else>
              <i class="fas fa-times text-danger"></i> กดเลือกไม่ได้
            </span>
          </div>
        </div>
        <div v-for="(childTag, key) in multiLevelTag.child_tags" :key="key">
          <div class="d-flex justify-content-start align-items-center mb-3 pl-5">
            <div class="rounded-left p-2"
                 :style="`background-color: ${childTag.color}; border: 1px ${childTag.color};`">
              <i class="fa fa-tag text-white"></i>
            </div>
            <div class="border p-2 text-small flex-grow-1 bg-white rounded-right">{{ childTag.name }}</div>
            <div class="px-4 text-small text-secondary">
              <span v-if="childTag.can_select">
                <i class="fas fa-check text-success"></i> กดเลือกได้
              </span>
              <span v-else>
                <i class="fas fa-times text-danger"></i> กดเลือกไม่ได้
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal change customer name -->
    <div>
      <b-modal id="modal-edit-tag"
               :title="(hasSystem) ? 'เพิ่มหัวข้อสนทนา' : 'เพิ่มแท็ก'"
               ok-variant="info"
               ok-title="ยืนยัน"
               cancel-title="ยกเลิก"
               @ok="validateAddingTag()">
        <div v-if="hasSystem">
          <div class="form-group">
            <label class="radio-inline mb-0">
              <input type="radio" name="parentId" v-model="hasParent" :value="0">&nbsp;&nbsp;หัวข้อหลัก
            </label>
            <label class="radio-inline mb-0 ml-3">
              <input type="radio" name="parentId" v-model="hasParent" :value="1">&nbsp;&nbsp;หัวข้อรอง
            </label>
          </div>
          <div v-if="hasParent">
            <div class="form-group">
              <select class="form-control" v-model="parentId">
                <option :value="null">เลือกหัวข้อสนทนาหลัก</option>
                <template v-for="(systemTag, index) in systemTags">
                  <option :value="systemTag.id"
                          :style="`color:${systemTag.color};`"
                          :key="index"
                          v-if="!systemTag.parent_id">{{ systemTag.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>
        <div class="border p-2 mb-3 rounded" v-if="hasSystem">
          <div class="form-group mb-0">
            <input type="checkbox" id="canSelectTag" v-model="tag.can_select" :true-value="1" :false-value="0">
            <label for="canSelectTag">&nbsp;&nbsp;สามารถกดเลือกหัวข้อได้</label>
            <div class="pt-2 text-small">
              <span class="text-danger">*หมายเหตุ</span> หัวข้อที่กดเลือกได้<br>
              1) หัวข้อรองทุกข้อ<br>
              2) หัวข้อหลักที่ไม่มีหัวข้อร้อง
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="name">
            {{ hasSystem ? 'ชื่อหัวข้อสนทนา (ไม่เกิน 20 ตัวอักษร)' : 'ชื่อแท็ก' }}
          </label>
          <input type="text"
                 class="form-control"
                 id="name"
                 maxlength="20"
                 v-model="tag.name">
        </div>
        <div class="form-group">
          <label for="color">สี</label>
          <photoshop-picker v-model="colors"></photoshop-picker>
        </div>
        <div class="form-group" v-if="!hasSystem">
          <label for="customerType">แท็กสำหรับ</label>
          <select id="customerType" class="form-control" v-model="tag.customer_type" :disabled="hasSystem">
            <option value="customer">คุณลูกค้า</option>
            <option value="professional">ผู้สมัคร</option>
            <option value="beneat_professional">คุณแม่บ้าน</option>
            <option value="sales_product_customer">คุณลูกค้า (Sales)</option>
            <option value="recruitment_customer">คุณลูกค้า (Recruit)</option>
            <option value="recruitment_professional">คุณแม่บ้าน (Recruit)</option>
          <option value="mari_customer">คุณลูกค้า (Mari)</option>
          <option value="mari_professional">ผู้สมัคร (Mari)</option>
          </select>
        </div>
      </b-modal>
    </div>
  </section>

  <section v-else class="v2026-tag">
    <h4 class="v2026-tag-title">{{ isSystemMode2026 ? 'ตั้งค่าหัวข้อสนทนากับลูกค้า' : 'ตั้งค่าแท็ก' }}</h4>

    <div class="v2026-tag-toolbar">
      <button ref="addBtn" type="button" class="v2026-tag-btn-primary" @click="openAddV2026">
        <span class="v2026-tag-ico v2026-tag-ico--plus" aria-hidden="true"></span>
        {{ isSystemMode2026 ? 'เพิ่มหัวข้อ' : 'เพิ่มแท็ก' }}
      </button>
      <LoadingV2026 v-if="showInlineLoading" :label="inlineLoadingLabel"/>
    </div>

    <template v-if="!isSystemMode2026">
      <!-- The rail's idPrefix is repeated in the panel's aria-labelledby below. Both strings must
           change together or the panel silently loses its accessible name. -->
      <SettingsTabsV2026 :tabs="tagTabs"
                         :activeType="queryParams.customer_type"
                         ariaLabel="ประเภทแท็ก"
                         idPrefix="v2026-stab-tag-"
                         panelId="v2026-tag-panel"
                         @select="onSelectTypeV2026"/>

      <div id="v2026-tag-panel"
           ref="tagList"
           class="v2026-tag-panel"
           :class="{ 'is-narrow': isNarrow }"
           role="tabpanel"
           :aria-labelledby="'v2026-stab-tag-' + queryParams.customer_type"
           :aria-busy="isLoading || isSavingOrder ? 'true' : 'false'">
        <div v-if="isLoading && !tagRows.length" class="v2026-tag-loading" role="status">
          <LoadingV2026 label="กำลังโหลด"/>
        </div>

        <div v-else-if="loadError && !tagRows.length" class="v2026-tag-empty" role="status">
          <span class="v2026-tag-empty__ico v2026-tag-empty__ico--tag" aria-hidden="true"></span>
          <div class="v2026-tag-empty__title">โหลดแท็กไม่สำเร็จ</div>
          <div class="v2026-tag-empty__msg">{{ loadError }}</div>
          <button type="button"
                  class="v2026-tag-btn-ghost v2026-tag-empty__act"
                  @click="loadTagsV2026(queryParams.customer_type)">ลองใหม่</button>
        </div>

        <div v-else-if="!tagRows.length" class="v2026-tag-empty" role="status">
          <span class="v2026-tag-empty__ico v2026-tag-empty__ico--tag" aria-hidden="true"></span>
          <div class="v2026-tag-empty__title">ยังไม่มีแท็กในกลุ่มนี้</div>
          <div class="v2026-tag-empty__msg">เพิ่มแท็กเพื่อจัดกลุ่มบทสนทนาให้ค้นหาง่ายขึ้น</div>
          <button type="button"
                  class="v2026-tag-btn-ghost v2026-tag-empty__act"
                  @click="openAddV2026">เพิ่มแท็ก</button>
        </div>

        <draggable v-else
                   v-model="tags"
                   handle=".v2026-tag-grip"
                   ghostClass="v2026-tag-rowwrap--ghost"
                   chosenClass="v2026-tag-rowwrap--chosen"
                   dragClass="v2026-tag-rowwrap--drag"
                   :animation="prefersReducedMotion ? 0 : 150"
                   :disabled="isSavingOrder || !canReorder"
                   @start="onDragStartV2026"
                   @change="sortingEventV2026">
          <transition-group tag="div" :name="prefersReducedMotion ? null : 'v2026-tag-move'">
            <div v-for="tag in tags" :key="tag.id" class="v2026-tag-rowwrap">
              <!-- The inert legacy guard is kept: {np, op} are indices into this same list and the
                   server renumbers 0..n-1 over it, so filtering here would break index parity. -->
              <div v-if="tag.id"
                   class="v2026-tag-row"
                   :class="{ 'is-pending': pendingRowId === tag.id, 'is-reverted': revertedRowId === tag.id }">
                <span class="v2026-tag-chip"
                      :style="{ backgroundColor: tag.color, color: glyphOn(tag.color) }"
                      aria-hidden="true"></span>
                <span class="v2026-tag-name" :title="tag.name">{{ tag.name }}</span>
                <span class="v2026-tag-grip"
                      :class="{ 'is-disabled': !canReorder }"
                      :aria-disabled="canReorder ? null : 'true'"
                      aria-hidden="true"></span>
                <button type="button"
                        class="v2026-tag-btn-trash"
                        :disabled="isSavingOrder || deletingId === tag.id"
                        :aria-label="'ลบแท็ก ' + tag.name"
                        @click="openDeleteV2026(tag)">
                  <span class="v2026-tag-ico v2026-tag-ico--trash" aria-hidden="true"></span>
                </button>
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
    </template>

    <div v-else
         ref="topicList"
         class="v2026-tag-panel v2026-tag-panel--topics"
         :aria-busy="isLoading ? 'true' : 'false'">
      <div v-if="isLoading && !topicRows.length" class="v2026-tag-loading" role="status">
        <LoadingV2026 label="กำลังโหลด"/>
      </div>

      <div v-else-if="loadError && !topicRows.length" class="v2026-tag-empty" role="status">
        <span class="v2026-tag-empty__ico v2026-tag-empty__ico--topic" aria-hidden="true"></span>
        <div class="v2026-tag-empty__title">โหลดหัวข้อสนทนาไม่สำเร็จ</div>
        <div class="v2026-tag-empty__msg">{{ loadError }}</div>
        <button type="button"
                class="v2026-tag-btn-ghost v2026-tag-empty__act"
                @click="loadTagsV2026(queryParams.customer_type)">ลองใหม่</button>
      </div>

      <div v-else-if="!topicRows.length" class="v2026-tag-empty" role="status">
        <span class="v2026-tag-empty__ico v2026-tag-empty__ico--topic" aria-hidden="true"></span>
        <div class="v2026-tag-empty__title">ยังไม่มีหัวข้อสนทนา</div>
        <div class="v2026-tag-empty__msg">เพิ่มหัวข้อหลักก่อน แล้วจึงเพิ่มหัวข้อรองไว้ข้างใต้</div>
        <button type="button"
                class="v2026-tag-btn-ghost v2026-tag-empty__act"
                @click="openAddV2026">เพิ่มหัวข้อ</button>
      </div>

      <TagTopicTreeV2026 v-else :nodes="topicRows" :narrow="isTopicNarrow"/>
    </div>

    <TagFormModalV2026 :open="modalOpen"
                       :system="isSystemMode2026"
                       :parentOptions="parentOptions"
                       :typeOptions="tagTabs"
                       :defaultCustomerType="queryParams.customer_type"
                       :saving="isSaving"
                       @submit="submitTagV2026"
                       @close="closeAddV2026"/>

    <BaseConfirm :open="confirm.open"
                 :title="'ลบแท็ก “' + (confirm.target ? confirm.target.name : '') + '” ?'"
                 message="แท็กนี้จะถูกลบถาวรและกู้คืนไม่ได้ และจะถูกนำออกจากทุกบทสนทนาที่ติดแท็กนี้อยู่"
                 confirmLabel="ลบ"
                 cancelLabel="ยกเลิก"
                 variant="danger"
                 :busy="confirm.busy"
                 @confirm="acceptDeleteV2026"
                 @cancel="cancelDeleteV2026"/>

    <BaseToast :open="toast.open"
               :variant="toast.variant"
               :title="toast.title"
               :message="toast.message"
               :actionLabel="toast.actionLabel"
               :autoHideDelay="toast.autoHideDelay"
               @action="runToastAction"
               @close="onToastClose"/>
  </section>
</template>

<script>
import draggable from 'vuedraggable'
import { Sketch } from 'vue-color'
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
import SettingsTabsV2026 from '../components/settings/SettingsTabsV2026'
import TagFormModalV2026 from '../components/tag/TagFormModalV2026'
import TagTopicTreeV2026 from '../components/tag/TagTopicTreeV2026'
import BaseConfirm from '../components/coversation/BaseConfirm'
import BaseToast from '../components/coversation/BaseToast'
import LoadingV2026 from '../components/coversation/LoadingV2026'
import { TAG_TABS } from '../constants/settingsTabs'

export default {
  components: {
    'photoshop-picker': Sketch,
    draggable,
    SettingsTabsV2026,
    TagFormModalV2026,
    TagTopicTreeV2026,
    BaseConfirm,
    BaseToast,
    LoadingV2026
  },
  data () {
    return {
      queryParams: {
        include_count: false,
        customer_type: 'customer',
        system: 0
      },
      colors: '#1976D2',
      tag: {
        name: null,
        color: null,
        customer_type: 'customer',
        is_line_audience_group: 0,
        line_audience_group_id: null,
        can_select: 0,
        position: 0,
        system: 0
      },
      parentId: null,
      hasSystem: false,
      hasParent: 0,
      tagsClone: [],
      // version2026: FALSE restores today's bootstrap page verbatim — the b-nav tabs (including the
      // two-tabs-lit includes() quirk and the หัวข้อร้อง typo), the bare vuedraggable rows, the
      // b-modal add dialog with its unguarded empty-name path, and every $swal on this page and in
      // the tag store actions it calls. Flipping this boolean is the entire rollback.
      useV2026TagSettings: true,
      isLoading: false,
      loadError: '',
      isSavingOrder: false,
      showOrderSpinner: false,
      isNarrow: false,
      isTopicNarrow: false,
      prefersReducedMotion: false,
      modalOpen: false,
      isSaving: false,
      deletingId: null,
      pendingRowId: null,
      revertedRowId: null,
      confirm: {
        open: false,
        target: null,
        busy: false
      },
      toast: {
        open: false,
        variant: 'success',
        title: '',
        message: '',
        actionLabel: '',
        autoHideDelay: 2500,
        action: null
      }
    }
  },
  watch: {
    '$route': function (value) {
      if (Number(this.$route.query.system) === 1) {
        this.queryParams.system = this.$route.query.system
        this.hasSystem = true
      } else {
        this.queryParams.system = 0
        this.hasSystem = false
      }
      this.loadTags('customer')
    }
  },
  computed: {
    ...mapState('tag', ['tags', 'systemTags', 'multiLevelTags']),
    tags: {
      get () {
        return this.$store.state.tag.tags
      },
      set (value) {
        this.$store.commit('tag/SET_TAGS', value)
      }
    },
    // version2026, flag-ON only. hasSystem is data() assigned from two places (mounted and the
    // $route watcher), so it is false for one frame on a cold load of ?system=1 and the mode-A
    // shell flashes. The ON branch derives the mode instead of being told it; hasSystem itself is
    // untouched and the flag-OFF template still reads it.
    isSystemMode2026 () {
      return Number(this.$route.query.system) === 1
    },
    tagTabs () {
      return TAG_TABS
    },
    // The store initialises all three lists to null and is shared with six other consumers.
    tagRows () {
      return this.tags || []
    },
    topicRows () {
      return this.multiLevelTags || []
    },
    canReorder () {
      return this.tagRows.length >= 2
    },
    parentOptions () {
      return (this.systemTags || []).filter(systemTag => !systemTag.parent_id)
    },
    showInlineLoading () {
      const rows = this.isSystemMode2026 ? this.topicRows : this.tagRows
      return this.showOrderSpinner || (this.isLoading && rows.length > 0)
    },
    inlineLoadingLabel () {
      return this.showOrderSpinner ? 'กำลังบันทึกลำดับ' : 'กำลังโหลด'
    }
  },
  methods: {
    async loadTagsV2026 (customerType) {
      this.queryParams.customer_type = customerType
      this.isLoading = true
      this.loadError = ''
      try {
        if (this.isSystemMode2026) {
          this.queryParams.system = 1
          await this.fetchSystemTags(this.queryParams)
        } else {
          this.queryParams.system = 0
          await this.fetchTags(this.queryParams)
        }
      } catch (err) {
        // /tags answers { status, error } and axios rejects on any non-2xx — there is no
        // data.code === 200 idiom on this API, and the error key is `error`, not `message`.
        this.loadError = this.errorTextV2026(err)
        this.showToast('danger', this.isSystemMode2026 ? 'โหลดหัวข้อสนทนาไม่สำเร็จ' : 'โหลดแท็กไม่สำเร็จ', this.loadError)
      } finally {
        this.isLoading = false
        this.$nextTick(this.attachObserverV2026)
      }
    },
    errorTextV2026 (err) {
      const body = err && err.response && err.response.data
      return (body && body.error) || (err && err.message) || 'เกิดข้อผิดพลาด'
    },
    // AC-R3 asks for the rail to be disabled while a reorder writes. A real disabled on a
    // role="tab" drops it out of the tab order mid-write and teleports focus to <body>, so the
    // guard lives here instead and the shared rail keeps its five props.
    onSelectTypeV2026 (type) {
      if (this.isSavingOrder) return
      this.discardUndoV2026()
      this.loadTagsV2026(type)
    },

    openAddV2026 () {
      this._returnFocusEl = document.activeElement
      this.discardUndoV2026()
      this.modalOpen = true
    },
    closeAddV2026 () {
      this.modalOpen = false
      this.focusBack()
    },
    async submitTagV2026 (payload) {
      this.isSaving = true
      try {
        // axios directly, never tag/addTag: that action carries the store's $swal.
        await axios.post('/tags', payload)
        this.closeAddV2026()
        this.showToast('success', this.isSystemMode2026 ? 'เพิ่มหัวข้อแล้ว' : 'เพิ่มแท็กแล้ว', '')
        await this.loadTagsV2026(this.queryParams.customer_type)
      } catch (err) {
        // The dialog stays open so a typed name is never lost.
        this.showToast('danger', 'บันทึกไม่สำเร็จ', this.errorTextV2026(err))
      } finally {
        this.isSaving = false
      }
    },

    onDragStartV2026 () {
      this._preDropOrder = (this.tags || []).slice()
    },
    sortingEventV2026 (event) {
      const positionMove = event.moved || null
      if (!positionMove) return
      const element = positionMove.element || {}
      this.writeOrderV2026({
        np: positionMove.newIndex,
        op: positionMove.oldIndex,
        name: element.name || '',
        id: element.id || null,
        mode: 'drop'
      })
    },
    async writeOrderV2026 (move) {
      if (this.isSavingOrder) return
      this.discardUndoV2026()

      const customerType = this.queryParams.customer_type
      this._lastMove = { np: move.np, op: move.op, name: move.name, id: move.id }
      this.isSavingOrder = true
      this.pendingRowId = move.id
      // Delayed so a 120ms write does not flash a spinner.
      this._orderSpinnerTimer = setTimeout(() => { this.showOrderSpinner = true }, 200)

      const optimisticIds = this.tagRows.map(tag => tag.id).join(',')
      try {
        await axios.put('/tags/position', { np: move.np, op: move.op, customer_type: customerType })

        // reRunningPosition renumbers without an is_hidden filter while the list endpoint filters
        // with one, so a 200 does not prove the server moved the row the drop asked for. The
        // reconciling refetch is the only thing that catches that; it must not be optimised away.
        try {
          await this.fetchTags(this.queryParams)
        } catch (err) {
          this.showToast('danger', 'บันทึกลำดับแล้ว แต่โหลดข้อมูลล่าสุดไม่สำเร็จ', this.errorTextV2026(err), {
            actionLabel: 'ลองใหม่',
            autoHideDelay: 0,
            action: () => this.loadTagsV2026(customerType)
          })
          return
        }

        // Only a drop has an optimistic order to reconcile against: undo and retry send their PUT
        // against a list that is already back at the server's last known order.
        if (move.mode === 'drop' && this.tagRows.map(tag => tag.id).join(',') !== optimisticIds) {
          this.showToast('success', 'ลำดับถูกปรับตามข้อมูลล่าสุด', 'รายการถูกจัดเรียงใหม่ตามข้อมูลบนเซิร์ฟเวอร์', {
            autoHideDelay: 4000
          })
          return
        }

        if (move.mode === 'undo') {
          this.showToast('success', 'เลิกทำแล้ว', '', { autoHideDelay: 2500 })
          return
        }

        // The inverse of a pairwise move is a pairwise move, so one-step undo is one more call to
        // an endpoint that already exists. One step deep, never a stack.
        this._undo = { np: move.op, op: move.np, name: move.name, id: move.id }
        this.showToast('success', 'บันทึกลำดับแล้ว',
          'ย้าย “' + move.name + '” ไปตำแหน่งที่ ' + (move.np + 1) + ' — ลากกลับได้ตลอดเวลา', {
            actionLabel: 'เลิกทำ',
            autoHideDelay: 6000,
            action: this.undoOrderV2026
          })
      } catch (err) {
        if (move.mode === 'drop' && this._preDropOrder) {
          this.tags = this._preDropOrder.slice()
          this.flashRevertedV2026(move.id)
        }
        this.showToast('danger', 'บันทึกลำดับไม่สำเร็จ', this.errorTextV2026(err), {
          actionLabel: 'ลองใหม่',
          autoHideDelay: 0,
          action: this.retryOrderV2026
        })
      } finally {
        clearTimeout(this._orderSpinnerTimer)
        this._orderSpinnerTimer = null
        this.showOrderSpinner = false
        this.isSavingOrder = false
        this.pendingRowId = null
      }
    },
    undoOrderV2026 () {
      const undo = this._undo
      if (!undo) return
      this._undo = null
      this.writeOrderV2026({ np: undo.np, op: undo.op, name: undo.name, id: undo.id, mode: 'undo' })
    },
    retryOrderV2026 () {
      const last = this._lastMove
      if (!last) return
      this.writeOrderV2026({ np: last.np, op: last.op, name: last.name, id: last.id, mode: 'retry' })
    },
    flashRevertedV2026 (id) {
      if (!id) return
      this.revertedRowId = id
      clearTimeout(this._revertTimer)
      this._revertTimer = setTimeout(() => { this.revertedRowId = null },
        this.prefersReducedMotion ? 1200 : 600)
    },
    // reRunningPosition recomputes from live data, so after an add, a delete, another drop, a tab
    // change, a mode change, a route leave or the toast expiring the stored {np, op} no longer
    // describes the same rows. Discard it rather than keep a dead button.
    discardUndoV2026 () {
      if (!this._undo) return
      this._undo = null
      this.toast.actionLabel = ''
      this.toast.action = null
    },

    openDeleteV2026 (tag) {
      this._returnFocusEl = document.activeElement
      this.discardUndoV2026()
      this.confirm = { open: true, target: tag, busy: false }
    },
    cancelDeleteV2026 () {
      this.confirm = { open: false, target: null, busy: false }
      this.focusBack()
    },
    async acceptDeleteV2026 () {
      const target = this.confirm.target
      if (!target) return

      this.confirm.busy = true
      this.deletingId = target.id
      let removed = false
      try {
        // axios directly, never tag/deleteTag: that action swallows every error and returns nothing.
        await axios.delete('/tags/' + target.id)
        removed = true
        this.showToast('success', 'ลบแท็กแล้ว', '')
        await this.loadTagsV2026(this.queryParams.customer_type)
      } catch (err) {
        this.showToast('danger', 'ลบไม่สำเร็จ', this.errorTextV2026(err))
      } finally {
        // Closed on failure too: leaving a destructive dialog open after an ambiguous failure
        // invites a double-fire.
        this.confirm = { open: false, target: null, busy: false }
        this.deletingId = null
        if (removed) this._returnFocusEl = this.$refs.addBtn || null
        this.focusBack()
      }
    },

    showToast (variant, title, message, options) {
      const opts = options || {}
      this.toast = {
        open: true,
        variant,
        title,
        message,
        actionLabel: opts.actionLabel || '',
        autoHideDelay: typeof opts.autoHideDelay === 'number' ? opts.autoHideDelay : (variant === 'danger' ? 5000 : 2500),
        action: opts.action || null
      }
    },
    runToastAction () {
      const action = this.toast.action
      this.toast.open = false
      if (action) action()
    },
    onToastClose () {
      this.toast.open = false
      this.discardUndoV2026()
    },
    focusBack () {
      const el = this._returnFocusEl
      this._returnFocusEl = null
      this.$nextTick(() => {
        if (el && typeof el.focus === 'function') el.focus()
      })
    },
    // The viewport lies on this route: the settings menu collapses at 992px, so the page is WIDER
    // at 900px than at 1024px. Measure the list element.
    measureLayout () {
      const list = this.$refs.tagList
      if (list) this.isNarrow = list.clientWidth < 560
      const topics = this.$refs.topicList
      if (topics) this.isTopicNarrow = topics.clientWidth < 480
    },
    // The two panels swap on a mode change, so the observed element has to be re-attached.
    attachObserverV2026 () {
      this.measureLayout()
      if (typeof ResizeObserver === 'undefined') return
      const el = this.$refs.tagList || this.$refs.topicList
      if (!el || el === this._roTarget) return
      if (this._ro) this._ro.disconnect()
      this._ro = new ResizeObserver(this.measureLayout)
      this._ro.observe(el)
      this._roTarget = el
    },
    glyphOn (hex) {
      // White on a dark tag, near-black on a pale one, so a pale tag is not a blank square.
      // 0.215 is the luminance at which #FFFFFF and #212529 contrast equally with the background.
      return this.relativeLuminanceV2026(hex) > 0.215 ? '#212529' : '#ffffff'
    },
    relativeLuminanceV2026 (hex) {
      const raw = String(hex || '').trim().replace('#', '')
      let full = raw
      if (raw.length === 3) full = raw[0] + raw[0] + raw[1] + raw[1] + raw[2] + raw[2]
      if (full.length !== 6 || !/^[0-9a-fA-F]{6}$/.test(full)) return 0
      const channel = (v) => {
        const c = parseInt(v, 16) / 255
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
      }
      return 0.2126 * channel(full.slice(0, 2)) +
        0.7152 * channel(full.slice(2, 4)) +
        0.0722 * channel(full.slice(4, 6))
    },
    async sortingEvent (event) {
      const positionMove = event.moved || null
      if (positionMove) {
        const np = positionMove.newIndex
        const op = positionMove.oldIndex

        const { data } = await axios.put('/tags/position', {
          np,
          op,
          customer_type: this.queryParams.customer_type
        })
        if (data.error) {
          this.$swal({ text: 'ผิดพลาด ' + data.message, icon: 'error' })
        }
      }
    },
    ...mapActions('tag', ['fetchTags', 'deleteTag', 'addTag', 'fetchSystemTags']),
    displayModal () {
      this.$bvModal.show('modal-edit-tag')
    },
    async validateAddingTag () {
      this.tag.color = (this.colors.hex) ? this.colors.hex : this.colors
      if (this.tag.name) {
        if (this.$route.query.system) {
          this.tag.system = 1
          // Check missing # symbol for customer chat topic tag
          if (this.tag.name.charAt(0) !== '#') {
            this.tag.name = `#${this.tag.name}`
          }
        } else {
          this.tag.system = 0
        }
        if (this.parentId) {
          this.tag.parent_id = this.parentId
        }
        await this.addTag(this.tag)
        this.$bvModal.hide('modal-edit-tag')
        await this.loadTags(this.queryParams.customer_type)
      }
    },
    async loadTags (customerType) {
      // The only legacy method the ON path still reaches: mounted and the $route watcher both call
      // it. sortingEvent / validateAddingTag / confirmDeleteTag are bound in the flag-OFF tree only
      // and are left completely untouched.
      if (this.useV2026TagSettings) {
        await this.loadTagsV2026(customerType)
        return
      }
      this.queryParams.customer_type = customerType
      if (Number(this.$route.query.system) === 1) {
        this.queryParams.system = this.$route.query.system
        this.hasSystem = true
        await this.fetchSystemTags(this.queryParams)
      } else {
        await this.fetchTags(this.queryParams)
      }
    },
    async confirmDeleteTag (tag) {
      this.$swal({
        text: 'คุณต้องการลบแท็กนี้ใช่หรือไม่',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.deleteTag(tag.id)
          await this.loadTags(this.queryParams.customer_type)
        }
      })
    }
  },
  async mounted () {
    await this.loadTags('customer')
    if (!this.useV2026TagSettings) return
    this.prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
    this.$nextTick(this.attachObserverV2026)
    window.addEventListener('resize', this.measureLayout)
  },
  beforeDestroy () {
    if (!this.useV2026TagSettings) return
    if (this._ro) {
      this._ro.disconnect()
      this._ro = null
      this._roTarget = null
    }
    window.removeEventListener('resize', this.measureLayout)
    clearTimeout(this._orderSpinnerTimer)
    clearTimeout(this._revertTimer)
    this._undo = null
  }
}
</script>

<style lang="scss" scoped>

/* Only the ten --v2026-color-* tokens declared on .v2026-shell resolve under /settings, so every
   grey below is hard-coded on purpose. */
.v2026-tag {
  padding: 16px 16px 48px;
  background: #ffffff;
  /* NO overflow: .v2026-settings-content must stay the only vertical scroller. */
}

.v2026-tag-title {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
  color: #212529;
}

.v2026-tag-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 0 8px;
}

.v2026-tag-panel { padding-top: 12px; }

/* No tabs above this list, so the sticky head's border-top is the first rule — match
   .v2026-mt-list sitting under SettingsTabsV2026 rather than adding another 12px gap. */
.v2026-tag-panel--topics { padding-top: 4px; }

.v2026-tag-rowwrap {
  border-radius: 8px;

  &--chosen { background: var(--v2026-color-hover-bg); }
  &--drag {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, .16);
    opacity: 1;
  }
  /* The placeholder must read as a slot, not a duplicate of the row being dragged. */
  &--ghost {
    background: var(--v2026-color-main-soft);
    opacity: .6;

    > * { visibility: hidden; }
  }
}

.v2026-tag-row {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) 32px 32px;
  column-gap: 12px;
  align-items: center;
  min-height: 56px;
  padding: 8px 0;
  border-radius: 8px;
  transition: background-color 150ms ease, box-shadow 150ms ease;

  &.is-pending { box-shadow: inset 0 0 0 1px rgba(49, 193, 215, .45); }
  &.is-reverted { animation: v2026-tag-revert 600ms ease-out; }

  .v2026-tag-panel.is-narrow & { column-gap: 8px; }
}

@keyframes v2026-tag-revert {
  from { background: #FEF2F2; }
  to { background: transparent; }
}

.v2026-tag-chip {
  width: 32px;
  height: 32px;
  justify-self: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* A white or near-white tag stays a visible square instead of a hole in the row. */
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .08);

  &::before {
    content: '';
    width: 16px;
    height: 16px;
    background-color: currentColor;
    -webkit-mask: url('~@/assets/icons2026/tag.svg') center / contain no-repeat;
            mask: url('~@/assets/icons2026/tag.svg') center / contain no-repeat;
  }
}

.v2026-tag-name {
  min-width: 0;
  font-size: 14px;
  color: #212529;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* aria-hidden, not a <button>: it is a pointer-only affordance in this run, and a focusable button
   that does nothing when pressed is a worse lie than not offering it to the keyboard at all. */
.v2026-tag-grip {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #98A2B3;
  cursor: grab;
  touch-action: none;

  &::before {
    content: '';
    width: 10px;
    height: 16px;
    background-image: radial-gradient(currentColor 1px, transparent 1.2px);
    background-size: 5px 5px;
    background-position: 0 2px;
    background-repeat: repeat;
  }

  &:hover { background: var(--v2026-color-hover-bg); color: #66696C; }
  &.is-disabled { color: #D0D5DD; cursor: default; background: none; }
}

.v2026-tag-btn-trash {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: none;
  cursor: pointer;

  &:hover:not(:disabled) { background: #FEF2F2; }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
  &:disabled { opacity: .5; cursor: default; }
}

.v2026-tag-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: var(--v2026-color-main);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) { filter: brightness(.94); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
  &:disabled { opacity: .5; cursor: default; }
}

.v2026-tag-btn-ghost {
  height: 36px;
  padding: 0 14px;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  color: #212529;
  cursor: pointer;
  white-space: nowrap;

  &:hover { background: var(--v2026-color-hover-bg); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
}

.v2026-tag-ico {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: var(--v2026-color-icon-idle);
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
}

.v2026-tag-ico--plus {
  background-color: #ffffff;
  -webkit-mask-image: url('~@/assets/icons2026/plus.svg');
          mask-image: url('~@/assets/icons2026/plus.svg');
}

.v2026-tag-ico--trash {
  background-color: #E5484D;
  -webkit-mask-image: url('~@/assets/icons2026/trash.svg');
          mask-image: url('~@/assets/icons2026/trash.svg');
}

.v2026-tag-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  /* Roughly four rows at 56px, so the swap to rows or to the empty state barely moves the page. */
  min-height: 224px;
}

.v2026-tag-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 56px 16px;
}

.v2026-tag-empty__ico {
  width: 40px;
  height: 40px;
  background-color: #66696C;
  opacity: .55;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
}

.v2026-tag-empty__ico--tag {
  -webkit-mask-image: url('~@/assets/icons2026/tag.svg');
          mask-image: url('~@/assets/icons2026/tag.svg');
}

.v2026-tag-empty__ico--topic {
  -webkit-mask-image: url('~@/assets/icons2026/topic.svg');
          mask-image: url('~@/assets/icons2026/topic.svg');
}

.v2026-tag-empty__title {
  font-size: 15px;
  font-weight: 600;
  color: #212529;
}

.v2026-tag-empty__msg {
  font-size: 13px;
  color: #66696C;
  max-width: 420px;
}

.v2026-tag-empty__act { margin-top: 8px; }

.v2026-tag-move-move { transition: transform 150ms ease; }

@media (prefers-reduced-motion: reduce) {
  .v2026-tag-row { transition: none; animation: none; }
  .v2026-tag-row.is-reverted { background: #FEF2F2; }
  .v2026-tag-move-move { transition: none; }
}
</style>
